<template>
  <div class="panicBuying-list">
    <div v-if="activityList.length">
      <div
        v-for="activityItem in activityList"
        :key="activityItem.promotionId"
        class="panicBuying-item"
      >
        <div
          class="panicBuying-item-img"
          @click="activityDetail(activityItem.promotionId)"
        >
          <img
            :src="activityItem.promotionUrl"
            alt=""
            class="car-img"
          >
          <div class="panicBuying-item-content">
            <div class="panicBuying-item-title">
              <div>{{activityItem.promotionName}}</div>
            </div>
            <count-down
            class="panicBuying-item-countDownBox"
            :currentTime="new Date().getTime()"
            :startTime="new Date(activityItem.promotionStartTime).getTime()"
            :endTime="new Date(activityItem.promotionEndTime ).getTime()"
            tipText="距活动开始"
            tipTextEnd="距活动结束"
            endText="活动已结束"
            dayTxt="天"
            secondsTxt=""
          ></count-down>
          </div>
        </div>
        <el-row
          :gutter="10"
          class="panicBuying-item-goods"
        >
          <el-col
            :span="4"
            v-for="goodItem in activityItem.commodityPromotionInfoVos"
            :key="goodItem.id"
          >
            <div class="panicBuying-item-good">
              <div
                class="panicBuying-item-good-img"
                @click="goodDetail(goodItem)"
              >
                <img
                  :src="goodItem.fileUrl || 'static/img/bitmap.png'"
                  :alt="goodItem.title"
                  class="panicBuying-item-good-img"
                >
              </div>
              <div class="panicBuying-item-good-price">
                <div class="activity-price">￥<font class="activity-price-size">{{ goodItem.price | formatePrice}}</font>
                </div>
                <div class="price"><!-- 原价： -->￥{{goodItem.sellingPrice | formatePrice}}</div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>
<script>
import { openOther } from '@/utils/index'
import CountDown from '@/components/count-down'
// import { goodDetailBuryingpoint } from '@/utils/eventTracking'
// import Cookies from 'js-cookie'
export default {
  name: 'seckillList', // 秒杀列表
  data () {
    return {
      activityList: []
    }
  },
  components: {
    CountDown
  },
  filters: {},
  mounted () {
    this.getActivityList()
  },
  methods: {
    // 获取活动列表
    getActivityList () {
      this.$store.commit('setLoadStatus', true)
      this.$request.get(`/front/order/payCommodityPromotion/queryPromotionListFront`)
        .then(data => {
          this.activityList = data || []
        })
        .catch(() => {
          this.activityList = []
        })
        .finally(() => {
          this.$store.commit('setLoadStatus', false)
        })
    },
    // 跳转商品详情
    goodDetail (good) {
      if (good) {
        // goodDetailBuryingpoint(name)
        openOther(`goodDetail?spuId=${good.spuId}&skuId=${good.skuId || ''}`)
      }
    },
    // 跳转活动详情
    activityDetail (id) {
      this.$router.push({ name: 'seckillDetail', query: { id: id } })
    }
  },
  beforeDestroy () {}
}
</script>
<style lang="scss" scoped>
.panicBuying-list {
  width: 1190px;
  margin: 0 auto;
  .panicBuying-item {
    .panicBuying-item-img {
      width: 100%;
      height: 384px;
      position: relative;
      cursor: pointer;
      .car-img {
        width: 100%;
        height: 384px;
      }
      .panicBuying-item-content {
        position: absolute;
        top: 50px;
        left: 20px;
        // padding: 40px;
        background-color: rgba(216, 216, 216, 0.8);
        color: #fff;
        width: 300px;
        height: 250px;
        border-radius: 10px;
        // opacity: 0.9;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .panicBuying-item-title {
          font-size: 30px;
          flex-grow: 1;
          display: flex;
          align-items: center;
          padding: 10px;
          // padding: 10px 20px;
        }
        .panicBuying-item-countDownBox {
          // width: 50%;
          flex-shrink: 0;
          background-color: #ccc;
          // margin: ;
          padding: 5px 5px;
          border-radius: 10px;
          /deep/.time-bg{
            text-align: center;
            background: #fff;
            color: #E02A21;
            padding: 5px;
            margin: 5px;
          }
        }
      }
    }
    .panicBuying-item-goods {
      margin: 10px 0;
      .panicBuying-item-good {
        background: #fff;
        .panicBuying-item-good-img {
          width: 100%;
          height: 157px;
          cursor: pointer;
        }
        .panicBuying-item-good-price {
          padding: 20px;
          font-size: 14px;
          color: #999999;
          .activity-price {
            color: #e33135;
            .activity-price-size {
              font-size: 26px;
            }
          }
        }
      }
    }
  }
  /deep/ .count-down-time-num {
    background-color: #fff;
    color: #e02a21;
    padding: 5px;
    text-align: center;
  }
}
</style>
